module.exports = __webpack_public_path__ + "static/media/micronav.9563a9a8.png";